import axios from "axios";

// 创建 axios 实例
const service = axios.create({
  // 大部分接口使用 zeno 开头的地址
  baseURL: "https://zeno.onechatai.cn/api",
  timeout: 10000,
});

// Request 拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("zeno_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 0) {
      // 处理业务错误
      console.error("API Error:", res.msg);
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return res.data;
    }
  },
  (error) => {
    console.error("Network Error:", error);
    return Promise.reject(error);
  }
);

export default service;
